
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/delivery-hero",
      function () {
        return require("private-next-pages/customers/delivery-hero.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/delivery-hero"])
      });
    }
  